import script from "./Menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Menu.vue?vue&type=script&setup=true&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=e37c0ce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e37c0ce2"]])

export default __exports__